import { useTheme } from "@fluentui/react/lib/Theme";
import { ComponentType, FunctionComponent } from "react";
import { Subtract } from "utility-types";
import { IWithThemeProps } from "./IWithThemeProps";

export function WithTheme<P extends IWithThemeProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithThemeProps>> {
  function ComponentWithTheme(props: Subtract<P, IWithThemeProps>) {
    const theme = useTheme();
    return <Component {...(props as P)} theme={theme} />;
  }

  const componentName = Component.displayName ?? Component.displayName ?? `Component`;
  ComponentWithTheme.displayName = `WithTheme(${componentName})`;

  return ComponentWithTheme;
}
